import { Modal } from '$components'
import { CreateSupportTicketForm } from '$features/support/forms/create-ticket'

type SubmitSupportTicketModalProps = {
  onClose: () => void
}

export function SubmitSupportTicketModal({ onClose }: SubmitSupportTicketModalProps) {
  return (
    <Modal onClose={onClose}>
      <CreateSupportTicketForm>
        <Modal.Header>
          <Modal.Heading>
            Submit A Support Ticket
          </Modal.Heading>
        </Modal.Header>

        <Modal.Content>
          <CreateSupportTicketForm.Content />
        </Modal.Content>

        <Modal.Footer>
          <CreateSupportTicketForm.Controls />
        </Modal.Footer>
      </CreateSupportTicketForm>
    </Modal>
  )
}
